import { DataTable } from "@msuite/ui/table";
import { useCalculation } from "@/hooks/use-calculation";
import type { CalculationPanelBaseProps } from "../shared";
import { columns } from "./table-config";

export function CalculationParsc({ calculationId }: CalculationPanelBaseProps) {
	/** Hooks */
	const { context, isLoading, queryKey, refetch } = useCalculation(calculationId);

	/** Render */
	return (
		<DataTable
			data={context?.parscs}
			columns={columns}
			persistenceKey="calculation-parsc-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={null}
		/>
	);
}
